<template>
  <div>
    <z-card width="250px" title="filtrar por condição">
      <template #content>
        <z-select
          v-model="selectedFilter"
          class="mb-2"
          hide-details
          :items="filters"
          return-object
          @change="valueToFilter = ''"
        ></z-select>
        <z-input
          v-if="selectedFilter && selectedFilter.value"
          v-model="valueToFilter"
          hide-details
        ></z-input>

        <div class="mt-2 d-flex">
          <v-spacer></v-spacer>
          <z-btn class="mr-2" text="cancelar" small @click="onCancel"></z-btn>
          <z-btn
            text="salvar"
            primary
            small
            @click="
              $emit('save', {
                filter: selectedFilter && selectedFilter.value,
                valueToFilter,
              })
            "
          ></z-btn>
        </div>
      </template>
    </z-card>
  </div>
</template>

<script>
export default {
  name: 'ZSimpleFilter',
  data() {
    return {
      selectedFilter: null,
      valueToFilter: null,
      filters: [
        {text: this.$t('none'), value: null},
        {text: this.$t('equals_to'), value: 'equal'},
        {text: this.$t('different_than'), value: 'different'},
        {text: this.$t('starts_with'), value: 'startsWith'},
        {text: this.$t('contains'), value: 'contains'},
        {text: this.$t('do_not_contains'), value: 'doNotContain'},
      ],
    }
  },

  methods: {
    onCancel() {
      this.selectedFilter = null
      this.valueToFilter = null

      this.$emit('cancel')
    },
  },

  i18n: {
    messages: {
      pt: {
        none: 'Nenhum',
        equals_to: 'Igual a',
        different_than: 'Diferente de',
        starts_with: 'Começa com',
        contains: 'Contém',
        do_not_contains: 'Não contém',
      },
      en: {
        none: 'None',
        equals_to: 'Equals to',
        different_than: 'Different than',
        starts_with: 'Starts with',
        contains: 'Contains',
        do_not_contains: 'Do not contains',
      },
      es: {
        none: 'Ninguna',
        equals_to: 'Igual a',
        different_than: 'Diferente de',
        starts_with: 'Comienza con',
        contains: 'Contiene',
        do_not_contains: 'No contiene',
      },
      fr: {
        none: 'Aucun',
        equals_to: 'Égal à',
        different_than: 'Différent de',
        starts_with: 'Commence par',
        contains: 'Contient',
        do_not_contains: 'Ne contient pas',
      },
      tr: {
        none: 'Hiçbiri',
        equals_to: 'Eşittir',
        different_than: 'Eşit değil',
        starts_with: 'İle başlar',
        contains: 'İçerir',
        do_not_contains: 'İçermez',
      },
    },
  },
}
</script>
